<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row dense no-gutters>
              <v-col cols="12">

                <v-row
                  dense
                >
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Ticket ID"
                      v-model="ticket"
                      :rules="[rules.required()]"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Domain"
                      v-model="domain"
                      :rules="[rules.required()]"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    class="text-right"
                  >
                    <v-text-field
                      dense
                      label="Purpose"
                      v-model="ticket"
                      :rules="[rules.required()]"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      @click="submitForm"
                    >Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentTicketNew',
  components: {
  },
  created() {
    this.id = +this.$route.params.id;
    this.$api.get(`agent/ticket/${this.$route.params.id}`).then((response) => {
      this.ticket = response.data.ticket;
      this.domain = response.data.domain;
      this.purpose = response.data.purpose;
    });
  },
  data() {
    return {
      id: 0,
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      valid: false,
      ticket: '',
      domain: '',
      purpose: '',
      form: {
      },
    };
  },
  methods: {
    submitForm() {
      this.processing = true;
      if (this.$refs.form.validate()) {
        this.$api.put('agent/ticket', {
          id: this.id,
          purpose: this.purpose,
        }).then(() => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'ticket request is acknowledged successfully.',
          });
        }).finally(() => {
          this.processing = false;
        });
      } else {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
